<template>
  <div v-if="loading" class="text-center py-5">
    <div class="spinner-border text-light" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>

  <template v-else>
    <template v-for="(artist, index) in artists" :key="artist._id">
      <!-- Hero section for artist name/subtitle/description -->
      <section :class="index === 0 ? 'hero d-flex align-items-center text-white' : 'hero py-3 d-flex align-items-center text-white'">
        <div class="container">
          <div class="row">
            <div class="col-12 text-center">
              <component :is="index === 0 ? 'h1' : 'h2'">
                <span class="highlight" v-html="artist.name"></span>
              </component>
              <h5 v-if="artist.subtitle" v-html="artist.subtitle"></h5>
              <p v-if="artist.description" v-html="artist.description"></p>
            </div>
          </div>
        </div>
      </section>

      <!-- Content section with image and bio -->
      <section class="text-white">
        <div class="container">
          <div class="row align-items-center">
            <div v-if="getImageUrl(artist.imagePath)" class="align-self-start col-md-6 mb-4 mb-md-0">
              <img 
                :src="getImageUrl(artist.imagePath)" 
                :alt="artist.imageAlt || artist.name" 
                class="img-fluid"
                @error="handleImageError"
              >
            </div>
            <div :class="getImageUrl(artist.imagePath) ? 'col-md-6' : 'col-12'" class="page-text" v-html="artist.bio"></div>
          </div>
        </div>
      </section>
    </template>

    <!-- Fallback if no artists -->
    <section v-if="artists.length === 0" class="hero d-flex align-items-center text-white">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <h1>About Us</h1>
            <p>Content coming soon...</p>
          </div>
        </div>
      </div>
    </section>
  </template>
</template>

<script>
export default {
  name: 'SiteAbout',
  data() {
    return {
      artists: [],
      loading: true
    };
  },
  created() {
    this.fetchArtists();
  },
  methods: {
    async fetchArtists() {
      try {
        const response = await fetch('/api/artists/public');
        const data = await response.json();
        if (data && data.status === 'success') {
          this.artists = data.artists;
        }
      } catch (error) {
        console.error('Error fetching artists:', error);
        this.artists = [];
      } finally {
        this.loading = false;
      }
    },
    getImageUrl(imagePath) {
      if (!imagePath) {
        return null;
      }
      // For artist images stored in the artists folder, use the server static route
      if (imagePath.startsWith('artists/')) {
        return `/images/${imagePath}`;
      }
      // For other images, try to require from assets
      try {
        return require(`@/assets/images/${imagePath}`);
      } catch (e) {
        console.warn(`Image not found: ${imagePath}`);
        return null;
      }
    },
    handleImageError(event) {
      // Hide image if it fails to load
      event.target.style.display = 'none';
    }
  }
}
</script>